<script setup>
defineProps({
  description: {
    type: String,
    default: undefined,
  },
});
</script>

<template>
  <div class="donation-block-payment-wrapper">
    <div class="donation-block-payment-wrapper__container">
      <slot>
        <img
          alt="donation title"
          class="donation-block-payment-wrapper__title"
          height="186"
          src="~/assets/images/donation-title.svg"
          width="1320"
        />
      </slot>
      <DonationBlockPayment :description="description" />
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.donation-block-payment-wrapper {
  position: relative;
  z-index: 1;
  margin-top: -100px;
  padding: 170px 0 50px;

  &::after {
    position: absolute;
    z-index: 1;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 1856px;
    height: 1194px;
    content: '';
    transform: translateX(-50%);
    background-image: url('~/assets/images/donation-background.svg');
  }

  &__container {
    position: relative;
    z-index: 2;
    max-width: var(--content-max-width);
    margin: 0 auto;
    padding: 0 60px;
  }

  &__title,
  :slotted(img) {
    width: 100%;
    max-width: 900px;
    height: auto;
    margin-bottom: 24px;
  }

  &__background-image {
    position: absolute;
    z-index: -1;
    top: 0;
    bottom: 0;
    left: 50%;
    width: auto;
    height: 100%;
    user-select: none;
    transform: translateX(-50%);
    pointer-events: none;
    object-fit: cover;
  }
  @media (--tablet-vp) {
    padding: 160px 0 50px;
  }

  @media (--small-vp) {
    margin-top: -60px;
    padding: 80px 0 30px;

    &__title,
    :slotted(img) {
      margin-bottom: 0;
    }

    &__container {
      padding: 0 12px 50px;

      &--padding {
        padding-bottom: 60px;
      }
    }
  }
}
</style>
